import type { ReactNode } from "react";

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Right-aligned buttons; wrap below the title on narrow widths. */
  actions?: ReactNode;
  /** Heading element — `h1` for a page (default), `h2` for a section inside a page that already has one. */
  as?: "h1" | "h2";
}

/** Page title (22/700), optional subtitle (13.5, `ds-ink2`) and an actions slot. */
export function PageHeader({ title, subtitle, actions, as: Heading = "h1" }: PageHeaderProps) {
  return (
    <div className="mb-3.5 flex flex-wrap items-end gap-x-4 gap-y-3">
      <div className="min-w-0 flex-1 basis-64">
        <Heading className="m-0 text-[22px] font-bold leading-tight tracking-[-0.01em] text-ds-ink">{title}</Heading>
        {subtitle && <p className="mt-0.5 text-[13.5px] text-ds-ink2">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
